import InvoiceListApp from "invoice/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const invoiceRoute: RouteObject = {
  path: "invoice",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: InvoiceListApp,
  }]
};